import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from 'modules';
import Setting from 'components/player/controlbar/Setting';

/**
 * 설정 컨테이너
 */

const initSettingState = {
  box: '',
  list: 'none',
};

const SettingContainer = () => {
  const {videoDOM} = useSelector((state: RootState) => ({
    videoDOM: state.video.videoDOM,
  }));
  const [displaySetting, setDisplaySetting] = useState(initSettingState);
  const [settingList, setSettingList] = useState('');

  // 셋팅 닫으면 초기화
  const closeSetting = () => {
    setDisplaySetting(initSettingState);
    setSettingList('');
  };

  // 셋팅 버튼 클릭
  const handleSettingClick = () => {
    if (displaySetting.box === 'on') {
      closeSetting();
    } else {
      setDisplaySetting({
        box: 'on',
        list: 'block',
      });
    }
  };

  return (
    // videoDOM 있을 경우에만 렌더링함
    videoDOM && (
      <Setting
        displaySetting={displaySetting}
        videoDOM={videoDOM}
        settingList={settingList}
        setSettingList={setSettingList}
        handleSettingClick={handleSettingClick}
        closeSetting={closeSetting}
        // handleBeforeClick={handleBeforeClick}
      />
    )
  );
};

export default SettingContainer;
